import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";

const ReceiptAccordionLabelContent = ({
    handlePrintClick = () => {},
    isActive,
    label,
    labelSubtext,
    printLinkLabel = "Print",
}) => {
    const suspendedPrintClick = (e) => {
        // open the accordion so the receipt html is visible.
        // then trigger the print function after 1 second.
        setTimeout(() => handlePrintClick(e), 1000);
    };

    return (
        <div className="grid">
            <div className="col col--8 col--no-top-gutter">
                <strong className="-type--regular -color--theme-primary">
                    {label}
                </strong>
                <br />
                {labelSubtext && (
                    <small className="-color--system-medium-dark -margin-top--5">
                        {labelSubtext}
                    </small>
                )}
            </div>
            <div className="col col--4 col--no-top-gutter -text--right">
                <p>
                    <button
                        type="button"
                        onClick={
                            isActive ? handlePrintClick : suspendedPrintClick
                        }
                    >
                        <Icon
                            className="-margin-right--5 -color--theme-primary"
                            glyph="print-regular"
                            type="FontAwesome"
                        />
                        <strong className="-color--theme-primary">
                            {printLinkLabel}
                        </strong>
                    </button>
                </p>
            </div>
        </div>
    );
};

ReceiptAccordionLabelContent.propTypes = {
    handlePrintClick: PropTypes.func,
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    labelSubtext: PropTypes.string,
    printLinkLabel: PropTypes.string,
};

export default ReceiptAccordionLabelContent;
